import { render, staticRenderFns } from "./BuildingSelect.vue?vue&type=template&id=1cb660e5&"
import script from "./BuildingSelect.vue?vue&type=script&lang=js&"
export * from "./BuildingSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports